<template>
  <div v-if="hasImpressions" style="padding: 10px;">
    <span class="headline cb-headlinenormalxl g-3 mb-4">
        Impressions
    </span>
    <div class="row g-3">
      <GalleryV2Loader
          :url="'/webapp/imageslider2/'"
          class="light-gray"
      />
    </div>
    <br>
  </div>
</template>

<script setup lang="ts">
import GalleryV2Loader from "@/components/GalleryV2Loader.vue";
import {computed} from "vue";
import {useStore} from "vuex";

const store = useStore()

const hasImpressions = computed(() => {
  return store.getters['hasImpressions'];
});
</script>
